import { useDispatch, useSelector } from 'react-redux';
import { useLink } from 'react-router-stack';
import { useEffect, useState } from 'react';
import {
  formattedWinningsPerPosition,
  getPropertyValueInPixels,
  getRealBalanceObj,
  isEligibleWalletBalance,
  isSmartPhone,
  ObjectToArray
} from '../../utilities/helper';
import { addGameToHistory } from '../../actions/mini-games-action-types';
import redirectPage from '../../hoc/redirect';
import PrizesMWeb from './index_mWeb';
import PrizesWeb from './index_web';

import { showErrorToast } from '../../actions/app-actions-types';
import useTheme from '../../utilities/hooks/theme';
import constants from '../../constants';
const Prizes = () => {
  const { gameDetails, gamesHistory = [] } = useSelector((state: any) => state.minigames);
  const { teamName = '' } = useSelector((state: any) => state.user);
  const { MoreTheme: theme } = useTheme();

  const [confimationModal, setConfirmationModal] = useState(false);
  const { contest, gameSlug, currentScore = 0, leaderboard = [], gameType } = gameDetails;
  const { winningsPerPosition, entryFee } = contest;
  const [prizes, setPrizes]: any = useState([]);
  const [leaderBoard, setLeaderBoard] = useState([]);
  const { balanceInfo } = useSelector((state: any) => state.user);
  const balance: any = getRealBalanceObj(balanceInfo);
  const [isGamePlayed, setIsGamePlayed] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const winningsPerPosition1 = winningsPerPosition['1'] || {}; //This represents winning amount in rupees
    const rupees: any = formattedWinningsPerPosition(winningsPerPosition1);
    let rupeesList = ObjectToArray(rupees, 'rupees');
    setPrizes(rupeesList);

    const isGameInHistory =
      gamesHistory.filter((item: any) => item.gameName === gameDetails?.gameName).length > 0;
    setIsGamePlayed(isGameInHistory);
    window.addEventListener('popstate', onClickBrowserBack);
    return () => {
      window.removeEventListener('popstate', onClickBrowserBack);
    };
  }, []);

  const onClickBrowserBack = () => {
    setConfirmationModal(false);
  };

  const navigate = useLink();

  const onPlayGameClick = () => {
    if (isEligibleWalletBalance(balance['totalBalance'], entryFee)) {
      setConfirmationModal(true);
    } else {
      dispatch(showErrorToast('Insufficient Funds'));
    }
  };
  const onPressDismiss = () => {
    setConfirmationModal(false);
  };

  const onConfirmationHandler = () => {
    setConfirmationModal(false);

    dispatch(addGameToHistory(gameDetails));
    if (gameType === 'playerVsPlayer') {
      navigate.push('/match_making');
    } else {
      navigate.push(`/games/${gameSlug}`);
    }
  };
  useEffect(() => {
    processData([...leaderboard, `78787:${teamName}:0`, currentScore]);
  }, [leaderboard]);

  const processData = (rawData: any) => {
    let data: any = [];
    let drawData: any = {};
    for (let i = 0; i < rawData.length; i = i + 2) {
      const elem = rawData[i];
      const items = elem.split(':');
      const previousPlayer: any = i === 0 ? {} : data[data.length - 1];
      const currentRank = i / 2 + 1;
      const currentScore = rawData[i + 1];
      let rank;
      if (previousPlayer?.score === currentScore) {
        rank = previousPlayer?.rank;
        drawData[currentRank] = previousPlayer?.rank;
      } else {
        rank = currentRank;
      }
      const player = {
        name: items[1],
        score: currentScore,
        rank,
        playerId: items[0]
      };
      data.push(player);
    }
    setLeaderBoard(data.slice(0, 11));
  };

  const slideLeft = (elementId: string) => {
    const container = document.getElementById(elementId) as HTMLInputElement;
    const scrollPixels =
      getPropertyValueInPixels(container, 'width') -
      getPropertyValueInPixels(container, 'padding-left') -
      getPropertyValueInPixels(container, 'padding-right');
    const currentPosition = container.scrollLeft;
    container.scroll({
      left: currentPosition - scrollPixels,
      behavior: 'smooth'
    });
  };
  const slideRight = (elementId: string) => {
    const container = document.getElementById(elementId) as HTMLInputElement;
    const scrollPixels =
      getPropertyValueInPixels(container, 'width') -
      getPropertyValueInPixels(container, 'padding-left') -
      getPropertyValueInPixels(container, 'padding-right');
    const currentPosition = container.scrollLeft;
    container.scroll({
      left: scrollPixels + currentPosition,
      behavior: 'smooth'
    });
  };

  const tableContainerStyle = {
    border: `1px solid ${theme.leaderBoardTableBorder}`
  };

  const tableHeaderStyle = {
    background: theme.leaderBoardTableHeaderBg,
    boxShadow: theme.leaderBoardTableHeaderBoxShadow,
    color: theme.leaderBoardTableHeaderColor,
    borderBottom: `1px solid ${theme.leaderBoardTableBorder}`
  };

  const tableRowStyle1 = {
    background: theme.leaderBoardRowStyleBg
  };
  const tableRowStyle2 = {
    background: theme.leaderBoardRowStyleBgDefault
  };

  const matchFlagStyle = {
    background: theme.minigamesMatchFlagBg,
    boxShadow: theme.minigamesMatchFlagBoxShadow
  };
  const poolPrizeEntryfeeHeaderStyle = {
    background: theme.mingamesPoolPrizeEntryFeeHeaderBg,
    borderLeft: `2px solid ${theme.minigamesGamePrizePoolTimerItemBorder}`,
    borderRight: `2px solid ${theme.minigamesGamePrizePoolTimerItemBorder}`,
    borderTop: `2px solid ${theme.minigamesGamePrizePoolTimerItemBorder}`
  };

  const rupeeCoinWrapperStyle = {
    border: `2px solid ${theme.minigamesGamePrizePoolTimerItemBorder}`
  };
  const timerWrapperStyle = {
    borderRight: `2px solid ${theme.minigamesGamePrizePoolTimerItemBorder}`,
    borderBottom: `2px solid ${theme.minigamesGamePrizePoolTimerItemBorder}`,
    borderTop: `2px solid ${theme.minigamesGamePrizePoolTimerItemBorder}`
  };
  const prizeTimeWrapperStyle = {
    background: theme.minigamesPoolPrizeEntryFeeValueBg,
    boxShadow: theme.minigamesPoolPrizeEntryFeeValueBoxShadow
  };
  const rupeeCoinBackDropStyle = {
    background: theme.gameInfoRuppeCoinBackDropBg,
    borderTop: `1px solid ${theme.gameInfoRuppeCoinBackDropBorder}`,
    borderBottom: `1px solid ${theme.gameInfoRuppeCoinBackDropBorder}`
  };
  const highScorePillStyle = {
    backgroundImage: `url(${constants.Images.highestScoreBorder})`
  };
  const currentScorePillStyle = {
    backgroundImage: `url(${constants.Images.currentScoreBorder})`
  };
  const highScorePillStyleMobile = {
    border: `1px solid ${theme.highestScorePillBorder}`
  };
  const currentScorePillStyleMobile = {
    border: `1px solid ${theme.currentScorePillBorder}`
  };

  const playGameBtnStyle = {
    background: theme.minigamesPlayBtnBg,
    border: `1px solid ${theme.minigamesPlayBtnBorder}`
  };

  if (isSmartPhone) {
    return (
      <PrizesMWeb
        gameDetails={gameDetails}
        prizes={prizes}
        onPlayGameClick={onPlayGameClick}
        onPressDismiss={onPressDismiss}
        confirmationModal={confimationModal}
        onConfirmationHandler={onConfirmationHandler}
        tableContainerStyle={tableContainerStyle}
        tableRowStyle2={tableRowStyle2}
        tableRowStyle1={tableRowStyle1}
        tableHeaderStyle={tableHeaderStyle}
        teamName={teamName}
        leaderBoard={leaderBoard}
        matchFlagStyle={matchFlagStyle}
        poolPrizeEntryfeeHeaderStyle={poolPrizeEntryfeeHeaderStyle}
        rupeeCoinWrapperStyle={rupeeCoinWrapperStyle}
        timerWrapperStyle={timerWrapperStyle}
        prizeTimeWrapperStyle={prizeTimeWrapperStyle}
        rupeeCoinBackDropStyle={rupeeCoinBackDropStyle}
        currentScorePillStyle={currentScorePillStyleMobile}
        highScorePillStyle={highScorePillStyleMobile}
        isGamePlayed={isGamePlayed}
        playGameBtnStyle={playGameBtnStyle}
      />
    );
  } else {
    return (
      <PrizesWeb
        gameDetails={gameDetails}
        prizes={prizes}
        onPlayGameClick={onPlayGameClick}
        onPressDismiss={onPressDismiss}
        confirmationModal={confimationModal}
        onConfirmationHandler={onConfirmationHandler}
        leaderBoard={leaderBoard}
        teamName={teamName}
        slideLeft={slideLeft}
        slideRight={slideRight}
        isGamePlayed={isGamePlayed}
        tableContainerStyle={tableContainerStyle}
        tableRowStyle2={tableRowStyle2}
        tableRowStyle1={tableRowStyle1}
        tableHeaderStyle={tableHeaderStyle}
        rupeeCoinBackDropStyle={rupeeCoinBackDropStyle}
        currentScorePillStyle={currentScorePillStyle}
        highScorePillStyle={highScorePillStyle}
        playGameBtnStyle={playGameBtnStyle}
      />
    );
  }
};

export default redirectPage(Prizes);
